import PropTypes from 'prop-types';
import Flux from '../../flux/Flux';
import ActorTileV2 from '../Grid2/Tiles/Actor/ActorTileV2.js';
import style from '../Grid2/Tiles/VideoStars/VideoStarTopTile.module.less';
import { getBadges } from '../Grid2/Tiles/Actor/Helper.js';
import Translations from '../../utils/Translations.js';
import { getButtonForCategory } from './TopCamsHelper.js';
import { Component } from 'react';

class TopCamsTopTile extends Component {
	constructor(props) {
		super(props);
	}

	getPlaceClass(index) {
		switch (index) {
			case 0:
				return style.iconPlace1;
			case 1:
				return style.iconPlace2;
			case 2:
				return style.iconPlace3;
		}
	}

	getTilePlateForCategory(category) {
		const modelData = this.props.data;
		let tilePlate;

		switch (category) {
			case Flux.Constants.TopCams.Categories.FAVORITES:
				tilePlate = (
					<div className={style.tilePlate}>
						<span className={style.tilePlateTextContainer}>
							{' '}
							<i className={`${style.tilePlateIcon} ${this.getPlaceClass(this.props.config.index)} icon -icon-award-full`} />
							{this.props.data.pinnedCount ? (
								<>
									<i className={`${style.tilePlateIcon} icon -icon-heart-full`} />
									<span className={style.tilePlateText}>
										{this.props.data.pinnedCount} {Translations.get('common.added')}
									</span>
								</>
							) : (
								''
							)}
						</span>
					</div>
				);
				break;
			case Flux.Constants.TopCams.Categories.BEST_CHATS:
				tilePlate = (
					<div className={style.tilePlate}>
						<span className={style.tilePlateTextContainer}>
							{' '}
							<i className={`${style.tilePlateIcon} ${this.getPlaceClass(this.props.config.index)} icon -icon-award-full`} />
							<i className={`${style.tilePlateIcon} icon -icon-like-full`} />
							<span className={style.tilePlateText}>
								{Math.round(this.props.data.satisfactionRate * 100)}%{' '}
								<span className={style.tilePlateSubtext}>
									/ {this.props.data.ratingCount} {Translations.get('ActorProfileChatRatingChats')}
								</span>
							</span>
						</span>
					</div>
				);
				break;
			case Flux.Constants.TopCams.Categories.VIDEOCALL:
				tilePlate = null;
				break;
			case Flux.Constants.TopCams.Categories.TOP_100:
			default:
				tilePlate = (
					<div className={style.tilePlate}>
						<span className={style.tilePlateTextContainer}>
							{' '}
							<i className={`${style.tilePlateIcon} ${this.getPlaceClass(this.props.config.index)} icon -icon-award-full`} />
							<span className={style.tilePlateText}>
								{Translations.get('Ranking')} {modelData.ranking}
							</span>
						</span>
					</div>
				);
		}
		return tilePlate;
	}

	render() {
		const index = this.props.config.index;
		let classSuffix = '';
		if (this.props.config.isMobile) {
			classSuffix += ' -is-mobile';
		}

		const badgeData = {
			online: this.props.data.online,
			onlineVideocall: this.props.data.onlineVideocall,
		};

		const badges = getBadges(badgeData);

		const tilePlate = this.getTilePlateForCategory(this.props.config.type);

		return (
			<ActorTileV2
				data={this.props.data}
				wrapperClasses={
					style.topTile +
					classSuffix +
					(index === 0 ? ' -first-tile' : '') +
					(index > 2 && !this.props.config.isMobile ? ' hide' : '') +
					(this.props.config.isDetailPage ? ' -detail-page' : '')
				}
				badges={badges}
				avatarSize={Flux.Constants.Grid2.ModelAvatar.Size.MD}
				showOfflineBorder={true}
				showAge={true}
				tilePlate={tilePlate}
				button={getButtonForCategory(this.props.config.type, this.props.data)}
			/>
		);
	}
}

TopCamsTopTile.propTypes = {
	data: PropTypes.object.isRequired,
	config: PropTypes.object,
};

TopCamsTopTile.defaultProps = {};

export default TopCamsTopTile;
